import { createAction } from '@reduxjs/toolkit';

import { CreateBroadcastPayload } from './broadcastTypes';

export const fetchBroadcast = createAction('broadcast/fetchBroadcast');

export const createBroadcast = createAction<CreateBroadcastPayload>('broadcast/createBroadcast');

export const stopBroadcastAction = createAction<string>('broadcast/stopBroadcast');
